<template>
    <div>
      <template v-if="is_day_direct_link === 0">

        <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" v-if="signedIn">
          <a class="navbar-brand" href="#">{{title_text}}</a>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
              <li>
                <router-link to="/sales_tasks" class="nav-link" >Tasks Admin</router-link>
              </li>
              <li>
                <router-link to="/history" class="nav-link" >History</router-link>
              </li>
<!--              <li>-->
<!--                <router-link to="/sales_task_day" class="nav-link" >Tasks SP TEST ONLY for design</router-link>-->
<!--              </li>-->
            </ul>
          </div>
        </nav>

        <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" v-if="!signedIn">
          <a class="navbar-brand" href="#">Sales</a>
          <button @click="signOut" class="nav-link">Sign In</button>
        </nav>

      </template>
      <template v-else>

  <!--          No bar at all-->


      </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {signOut} from '../utils/auth'

    export default {
        data() {
          return {
            title_text: process.env.VUE_APP_ADMIN_ENV_TEXT
          }
        },
        computed: {
            ...mapGetters({
              signedIn:'auth/signedIn',
              is_day_direct_link: 'admin/is_day_direct_link',
            }),
        },
        methods: {
            signOut() {
                signOut();
                this.$router.push("/signin");
            },
        }
    }
</script>
